import { render, staticRenderFns } from "./bkview.vue?vue&type=template&id=32587d93&scoped=true"
import script from "./bkview.vue?vue&type=script&lang=js"
export * from "./bkview.vue?vue&type=script&lang=js"
import style0 from "./bkview.vue?vue&type=style&index=0&id=32587d93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32587d93",
  null
  
)

export default component.exports